import I18n from 'I18n';
import { DateInput } from 'foundations-components/transitional/components/DateInput';
import _get from 'hs-lodash/get';
import { useCallback, useContext, useMemo, useState } from 'react';
import { AppContext } from '../../../contexts/app/context';
import UIInputWrapper from './UIInputWrapper/UIInputWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const FormDateInput = ({
  property,
  onChange,
  currentValue,
  editMode = false,
  disabled = false,
  defaultOpen = false
}) => {
  const {
    appName
  } = useContext(AppContext);
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const dateValue = useMemo(() => {
    const currentDate = I18n.moment(currentValue);
    const currentDateValue = {
      year: currentDate.year(),
      month: currentDate.month(),
      date: currentDate.date()
    };
    return currentValue ? currentDateValue : undefined;
  }, [currentValue]);
  const openHandler = open => setIsOpen(open.currentTarget.value);
  const onChangeDateHandler = useCallback(evt => {
    const eventValue = _get(evt, 'target.value');
    let value = '';
    if (eventValue) {
      const {
        date,
        month,
        year
      } = eventValue;
      value = new Date(Date.UTC(year, month, date));
    }
    onChange({
      key: property.name,
      value,
      required: !!property.required
    });
  }, [onChange, property]);
  return /*#__PURE__*/_jsx(UIInputWrapper, {
    property: property,
    editMode: editMode,
    ariaLabel: "form-date-input",
    dataTestId: `${appName}-form-date-input`,
    children: /*#__PURE__*/_jsx(DateInput, {
      onChange: onChangeDateHandler,
      value: dateValue,
      disabled: disabled,
      open: isOpen,
      onOpenChange: openHandler
    })
  });
};
export default FormDateInput;